import { useParams } from 'react-router-dom';
import { getRepo, type Article, type Category } from '../../lib/repo';
import { useAsync } from '../../lib/hooks';
import { ArticleCard } from '../../components/ArticleCard';
import { Seo } from '../../components/Seo';
import { EmptyState, Spinner } from '../../components/ui';
import { NotFoundPage } from './NotFoundPage';

export function CategoryPage() {
  const { slug = '' } = useParams();
  const { data: category, loading } = useAsync<Category | null>(() => getRepo().getCategoryBySlug(slug), [slug]);
  const { data: articles } = useAsync<Article[]>(
    () => (category ? getRepo().listPublicArticles({ categoryId: category.id, limit: 60 }) : Promise.resolve([])),
    [category?.id],
  );

  if (loading) return <Spinner label="Loading section…" />;
  if (!category) return <NotFoundPage />;

  const list = articles ?? [];
  const [lead, ...rest] = list;

  return (
    <>
      <Seo name="category" category={category} />
      <div className="mx-auto max-w-6xl px-4 py-10">
        <h1 className="font-display text-3xl font-semibold">{category.name}</h1>
        {category.description ? <p className="mt-2 text-muted">{category.description}</p> : null}

        <div className="mt-8">
          {lead ? <ArticleCard article={lead} variant="lead" /> : (
            <EmptyState title="Nothing published in this section yet" description="Check back soon, or browse another section." />
          )}
        </div>

        {rest.length ? (
          <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {rest.map((a) => <ArticleCard key={a.id} article={a} />)}
          </div>
        ) : null}
      </div>
    </>
  );
}
